export default {"src":"/_next/static/media/globe-dark.77b817ab.svg","height":34,"width":34};